import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layouts/PrimaryLayout/PrimaryLayout.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Source_Sans_3\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\",\"700\",\"900\"],\"variable\":\"--source-sans-3\"}],\"variableName\":\"sourceSans3\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Anton\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"400\",\"variable\":\"--anton\"}],\"variableName\":\"anton\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/components/BottomCollapseButton/BottomCollapseButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/components/BuyEveryCTA/BuyEveryCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/components/CasinoCategories/CasinoCategoriesClient/CasinoCategoriesClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/components/OtherSection/OtherSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/components/SearchButton/SearchButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/components/SectionDivider/SectionDivider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/components/SideNavItem/SideNavItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/components/TopExpandButton/TopExpandButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/data/OfferLinks/OfferLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/data/ProfileLinks/ProfileLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/SideNav/data/VipLinks/VipLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/TopNav/Hamburger/Hamburger.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layouts/TopNav/TopNav.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layouts/SideNav/SideNav.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/TopNav/ProfileDropdown/ProfileDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layouts/TopNav/VipProgress/VipProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Loaders/Loader_Page_Primary/Loader_Page_Primary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Modals/Modals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Notifications/Notifications.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Wallet/WalletPreview/WalletPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/GoogleTagManger/GoogleTagManger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/Onboarding/Onboarding.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/PixelAudienceObservability/PixelAudienceObservability.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/PrivySetup/PrivySetup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/Seo/HeadSchema/HeadSchema.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/WebsocketConnections/WebsocketConnections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/hooks/useWebSocket.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/buttonIcons/sliderArrow.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/bnb.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/bonk.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/btc.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/doge.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/eth.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/euro.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/every.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/ltc.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/matic.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/shib.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/sol.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/ton.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/trx.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/usdc.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/usdt.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/wif.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/currency/xrp.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/benefactor_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/entrepreneur_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/entrepreneur.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/investor_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/investor.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/jetsetter_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/jetsetter.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/landlord_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/landlord.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/magnate_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/mogul_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/mogul.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/owner_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/levels/owner.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/applepay.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/gpay.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/mastercard.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/moonpayLogo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/Icons/paymentMethods/visa.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/global.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/ds/ds.module.scss");
